import { createQueryData } from '../helpers/createQueryData';

const {
  useQuery: useScheduleTypesQuery,
  createKey: createScheduleTypesQueryKey,
  fn: fetchScheduleTypes,
} = createQueryData({
  endPoint: 'Acceptance/graph_types',
});

export {
  useScheduleTypesQuery,
  createScheduleTypesQueryKey,
  fetchScheduleTypes,
};
